export default (function () {
  return ['FBAN', 'FBAV'].find(function (agent) {
    return navigator.userAgent.includes(agent);
  }) !== undefined;
});